export default __webpack_public_path__ + "static/small-business-economy-accomplishment-3a-35e26dc3d5d59741a84cd1d193b663c2.webp";